module.exports = __webpack_public_path__ + "static/fonts/trebuchet_MS_Bold.b1eaa1e.eot";